import React from 'react';
import { useLocation } from 'react-router-dom';

import { motion as m } from 'framer-motion';

const Bookmark = () => {
  const animationVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const location = useLocation();
  const pathname = location.pathname;

  let content = null;

  if (pathname === '/about') {
    content = 'About me';
  } else if (pathname === '/projects') {
    content = 'Projects';
  } else if (pathname === '/contact') {
    content = 'Contact';
  }

  return (
    <m.div
      initial='hidden'
      animate='visible'
      variants={animationVariants}
      className='
        hidden md:flex col-span-2
        justify-center items-center
        lg:p-0 md:py-6'
        style={{ fontFamily: 'Ledger, serif' }}
    >
      <p className='
        opacity-5
        lg:-rotate-90
        whitespace-nowrap
        text-9xl
      '>
        {content}
      </p>
    </m.div>
  );
};

export default Bookmark;
